// src/pages/Support.jsx
import React from "react";

export default function Support() {
  return (
    <div style={{ maxWidth: "900px", margin: "0 auto", padding: "24px" }}>
      <h1>MyShopCity</h1>
      <h2>Contactar a soporte de la app</h2>

      <p>
        Si necesitas ayuda con el uso de <strong>MyShopCity</strong>, tienes
        dos formas de ponerte en contacto con nuestro equipo de soporte.
      </p>

      <h3>1. Correo electrónico de soporte</h3>
      <p>
        Puedes escribirnos directamente a nuestro correo de soporte:
      </p>
      <p>
        📧{" "}
        <a href="myshopcity@gmail.com">
          myshopcity@gmail.com
        </a>
      </p>
      <p>
        Por favor incluye en tu mensaje, si es posible:
      </p>
      <ul>
        <li>Tu nombre.</li>
        <li>Correo con el que estás registrado en la app.</li>
        <li>Descripción clara del problema o duda.</li>
        <li>Capturas de pantalla (si aplica).</li>
      </ul>

      <h3>2. Chat de soporte dentro de la app</h3>
      <p>
        La aplicación <strong>MyShopCity</strong> cuenta con un sistema de{" "}
        <strong>chat integrado</strong>, desde el cual puedes comunicarte
        con nuestro equipo de soporte directamente desde tu cuenta.
      </p>
      <p>
        Para usar el chat de soporte:
      </p>
      <ul>
        <li>Inicia sesión en la app.</li>
        <li>Ve a la sección de <strong>Chats</strong> o <strong>Soporte</strong>.</li>
        <li>Abre la conversación de soporte y envía tu mensaje.</li>
      </ul>
      <p>
        El chat de soporte se atiende únicamente{" "}
        <strong>en el horario de atención publicado dentro de la app</strong>.
        Fuera de ese horario puedes dejar tu mensaje y será respondido
        en cuanto el equipo esté disponible.
      </p>

      <h3>3. Información adicional</h3>
      <p>
        Nuestro objetivo es ayudarte con cualquier problema relacionado con:
      </p>
      <ul>
        <li>Creación o acceso a tu cuenta.</li>
        <li>Problemas con compras o pedidos.</li>
        <li>Dudas sobre el uso de la aplicación.</li>
        <li>Reportes de errores o fallos técnicos.</li>
        <li>Comentarios y sugerencias para mejorar MyShopCity.</li>
      </ul>

      <p>
        Agradecemos tu confianza en <strong>MyShopCity</strong> y trabajamos
        constantemente para ofrecer una experiencia segura y confiable para
        compradores y vendedores locales.
      </p>
    </div>
  );
}
